import { cn } from '@costar-ui/cosmos';
import React__default from 'react';
import { starSvgIcon } from './star-svg-icon.esm.js';
import { usePropId } from '../../../utils/use-prop-id.esm.js';

var SingleRatingStar = function SingleRatingStar(props) {
  var inactiveColor = props.inactiveColor,
    value = props.value,
    disabled = props.disabled,
    onClick = props.onClick,
    classNames = props.classNames,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    index = props.index,
    strokeFill = props.strokeFill,
    mode = props.mode;
  var id = usePropId();
  return /*#__PURE__*/React__default.createElement("svg", {
    mode: mode,
    "data-testid": "rating-star-".concat(index),
    viewBox: starSvgIcon.viewBox,
    className: cn([onClick && !disabled ? 'cursor-pointer' : '', disabled ? 'cursor-not-allowed' : '', classNames]),
    onClick: onClick,
    role: onClick ? 'button' : 'img',
    stroke: "currentcolor",
    fill: "currentcolor",
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, /*#__PURE__*/React__default.createElement(starSvgIcon.element, {
    id: id,
    fill: value,
    strokeFill: strokeFill,
    secondaryColor: inactiveColor,
    disabled: disabled
  }));
};

export { SingleRatingStar };
//# sourceMappingURL=single-rating-star.esm.js.map
